import {Typography} from "@mui/material";

const AuthTextfieldLabel = ({label}) => {

    return (
        <Typography sx={{fontSize: "12px", fontWeight: 600}}>{label}</Typography>
    );
};

export default AuthTextfieldLabel;